import { reducerWithInitialState } from 'typescript-fsa-reducers';
import {
    setPhoneVerificationData,
    setEmailVerificationData,
    set2FAData,
    resetAuthPageState,
} from './authPage.actions';

export interface AuthPageState {
    phoneNumber: string | undefined;
    verificationToken: string | undefined;
    emailAddress: string | undefined;
    verificationLevel: string | undefined;
    email2FA: string | undefined;
    password2FA: string | undefined;
}

export const defaultState: AuthPageState = {
    phoneNumber: undefined,
    verificationToken: undefined,
    emailAddress: undefined,
    verificationLevel: undefined,
    email2FA: undefined,
    password2FA: undefined,
};

export default reducerWithInitialState(defaultState)
    .case(setPhoneVerificationData, (state, payload) => ({
        ...state,
        phoneNumber: payload.phoneNumber,
        verificationToken: payload.verificationToken,
        emailAddress: undefined,
        verificationLevel: undefined,
        email2FA: undefined,
        password2FA: undefined,
    }))
    .case(setEmailVerificationData, (state, payload) => ({
        ...state,
        emailAddress: payload.emailAddress,
        verificationLevel: payload.verificationLevel,
        verificationToken: payload.verificationToken,
        phoneNumber: undefined,
        email2FA: undefined,
        password2FA: undefined,
    }))
    .case(set2FAData, (state, payload) => ({
        ...state,
        email2FA: payload.email,
        password2FA: payload.password,
        phoneNumber: undefined,
        verificationToken: undefined,
        emailAddress: undefined,
        verificationLevel: undefined,
    }))
    .case(resetAuthPageState, () => defaultState);
